import { Controller } from '@hotwired/stimulus';
import { apiErrorMessage } from '../../utils/api_error_message';
import { persistLowTimeModalPending } from '../../utils/case_experience/low_time_case_modal';
import { persistCaseCompletionModalPending } from '../../utils/case_experience/case_completion_modal';
import { clearLocalCaseProgress } from '../../utils/clear_local_case_progress';

// Connects to data-controller="case-experience--reset-case"
export default class extends Controller {
  static targets = ['resetCaseButton'];

  connect() {
    this.csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute('content');
  }

  reset = async (event) => {
    event.preventDefault();

    const btn = event.currentTarget;

    if (
      !confirm(
        'Are you sure you want to reset this case?  This will delete all of your work so you can go through the case again. Your previous work will not show in reports.',
      )
    ) {
      return;
    }

    btn.disabled = true;

    const url = btn.getAttribute('data-reset-url');

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': this.csrfToken,
          Accept: 'application/json',
        },
        credentials: 'same-origin',
      });

      if (response.ok) {
        // Clear only after success so a failed reset can still restore the modal on refresh.
        persistLowTimeModalPending(false);
        persistCaseCompletionModalPending(false);
        await clearLocalCaseProgress();
        window.location.reload();
      } else {
        const data = await response.json().catch(() => null);

        alert('Reset failed: ' + apiErrorMessage(data));
      }
    } catch (error) {
      console.error('Reset failed:', error);

      alert('Reset failed: Network error');
    } finally {
      btn.disabled = false;
    }
  };
}
